// iter616 — Training-mode banner. Visible at the top whenever the
// branch is in training. Forces every print to OS dialog so new
// staff see what would print before paper moves. Tap to disable.
export const TrainingModeBanner = ({ onDisable }) => (
  <button
    type="button"
    onClick={onDisable}
    data-testid="training-mode-banner"
    title="Tap to disable training mode"
    className="fixed top-0 left-0 right-0 z-[101] bg-amber-400 hover:bg-amber-500 text-amber-950 text-[12px] font-semibold py-1.5 px-3 flex items-center justify-center gap-2 transition-colors shadow-md"
  >
    <span role="img" aria-label="training">🎓</span>
    TRAINING MODE — every print opens the OS dialog. Click here to disable.
  </button>
);

export default TrainingModeBanner;
